import { render, staticRenderFns } from "./DatosGeneralesComponent.vue?vue&type=template&id=2242f73e&scoped=true"
import script from "./DatosGeneralesComponent.vue?vue&type=script&lang=js"
export * from "./DatosGeneralesComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosGeneralesComponent.vue?vue&type=style&index=0&id=2242f73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242f73e",
  null
  
)

export default component.exports